/* eslint consistent-return: off */
import decode from 'jwt-decode';

export const isAdmin = () => {
  const authData: any = localStorage.getItem('authAgencyData');
  if (!authData) return;
  const myToken = JSON.parse(authData);
  const tokenDecode: any = decode(myToken?.token);
  const hasAdmin = tokenDecode?.role === '1';
  return hasAdmin;
};
